<template>
  <div>
    <div v-if="!prospects" class="alert alert-info text-center">
      Sélectionnez des filtres et cliquez sur "Visualiser" pour afficher les
      prospects.
    </div>

    <el-table
      v-else
      :data="prospects"
      :default-sort="sorting"
      @row-click="goToClient"
      @sort-change="sortChangeHandler"
    >
      <el-table-column
        label="Ai"
        width="40"
        align="center"
        prop="prospect.urssafInscription"
        fixed="left"
      >
        <template slot-scope="scope" v-if="scope.row.urssafInscription">
          <template
            v-if="
              !scope.row.urssafInscription.idClient &&
              scope.row.urssafInscription.status === 'pending'
            "
          >
            <i class="fa fa-balance-scale text-danger" aria-hidden="true"></i>
          </template>
          <i
            v-else-if="scope.row.urssafInscription.idClient"
            class="fa fa-balance-scale text-success"
            aria-hidden="true"
          ></i>
          <i
            v-else-if="
              !scope.row.urssafInscription.idClient &&
              scope.row.urssafInscription.status === 'send'
            "
            class="fa fa-balance-scale text-warning"
            aria-hidden="true"
          ></i>
        </template>
      </el-table-column>

      <el-table-column label="Lead web" width="90" align="center" fixed="left">
        <template slot-scope="scope" v-if="scope.row.prospect.lastFormFilledAt">
          <i class="fa fa-wpforms text-primary" aria-hidden="true"></i>
        </template>
      </el-table-column>

      <el-table-column
        label="Statut"
        width="110"
        align="center"
        sortable="custom"
        prop="prospect.type"
        fixed="left"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.prospect && scope.row.prospect.type">
            <ProspectStatusBadge :status="scope.row.prospect.type" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Nom"
        min-width="100"
        sortable="custom"
        prop="lastName"
        fixed="left"
      ></el-table-column>
      <el-table-column
        label="Prénom"
        min-width="100"
        sortable="custom"
        prop="firstName"
        fixed="left"
      ></el-table-column>
      <el-table-column
        label="Société"
        width="100"
        sortable="custom"
        prop="company"
      ></el-table-column>
      <el-table-column
        label="CP"
        width="80"
        sortable="custom"
        prop="zipcode"
      ></el-table-column>
      <el-table-column
        label="Ville"
        min-width="180"
        sortable="custom"
        prop="city"
      ></el-table-column>
      <el-table-column
        label="Coachs secteur"
        width="130"
        align="center"
        prop="nbPrestatairesAround"
      >
      </el-table-column>
      <el-table-column label="Commerciaux" min-width="220">
        <template slot-scope="scope">
          <div class="d-flex align-items-center" style="gap: 15px">
            <div
              v-if="scope.row.commercials && scope.row.commercials.length > 0"
              class="d-flex flex-column"
              style="gap: 5px"
            >
              <CommercialRel
                v-for="commercialRel in scope.row.commercials"
                :key="commercialRel.id"
                :relation="commercialRel"
              />
            </div>
            <button
              class="btn btn-sm"
              @click.stop="editCommercials(scope.row)"
              v-if="hasPermission($store.state.user, 'CLIENTS_WRITE')"
            >
              <i class="fa fa-edit"></i>
            </button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Formulaire le"
        sortable="custom"
        prop="isProspectSince"
        width="150"
      >
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.prospectSince) }}
        </template>
      </el-table-column>
      <el-table-column width="225" label="Note">
        <template slot-scope="scope">
          <NoteModal
            style="margin-top: 1px"
            :notes="scope.row.prospect.note"
            :key="scope.row.id"
            v-if="hasPermission($store.state.user, 'CLIENTS_WRITE')"
            @showComment="showComment(scope.row)"
          />
          <span v-else>
            {{ scope.row.prospect.note }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="B2B" prop="isB2B" width="60" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.isB2B" class="fa fa-check-circle text-info"></i>
        </template>
      </el-table-column>
      <el-table-column
        label="Changer statut"
        width="140"
        v-if="hasPermission($store.state.user, 'CLIENTS_WRITE')"
      >
        <template slot-scope="scope">
          <ProspectStatusChangeButtons
            :current-status="scope.row.prospect.type"
            @change="(newStatus) => changeProspectType(scope.row, newStatus)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPermission($store.state.user, 'CLIENTS_WRITE')"
        label="Archives"
        width="90"
        align="center"
      >
        <template slot-scope="scope">
          <button
            v-if="!scope.row.archived"
            class="btn btn-sm btn-info"
            @click.stop="$emit('archiveProspect', scope.row)"
          >
            <i class="fa fa-briefcase"></i>
          </button>
          <i v-else class="fa fa-briefcase text-muted"></i>
        </template>
      </el-table-column>

      <div slot="empty">
        Cliquer sur le bouton "Visualiser" pour afficher les prospects.
      </div>
    </el-table>

    <paginate
      ref="paginate"
      :value="page"
      :page-count="count"
      :click-handler="paginationHandler"
      prev-text="Précédent"
      next-text="Suivant"
      container-class="pagination"
      class="pt-1"
    ></paginate>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import NoteModal from "@/components/form/NoteModal";
import ProspectStatusBadge from "@/components/client/ProspectStatusBadge";
import CommercialRel from "@/components/utils/CommercialRel";
import ProspectStatusChangeButtons from "@/components/client/ProspectStatusChangeButtons";

export default {
  components: {
    Paginate,
    NoteModal,
    ProspectStatusBadge,
    CommercialRel,
    ProspectStatusChangeButtons,
  },

  props: {
    prospects: {
      type: Array,
      default: null,
    },
    prospectsTotal: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    rows: {
      type: Number,
      default: 20,
    },
    sorting: {
      type: Object,
      default: () => ({
        prop: "isProspectSince",
        order: "descending",
      }),
    },
  },

  computed: {
    count() {
      return Math.ceil(this.prospectsTotal / this.rows);
    },
  },

  watch: {
    page() {
      this.$refs.paginate.selected = this.page - 1;
    },
  },

  methods: {
    paginationHandler(page) {
      this.$emit("changePage", page);
    },

    showComment(prospect) {
      this.$emit("showComment", prospect);
    },

    editCommercials(prospect) {
      this.$emit("editCommercials", prospect);
    },

    goToClient(prospect) {
      const route = this.$router.resolve({
        name: "client-details",
        params: {
          id: prospect.id,
        },
      });
      window.open(route.href, "_blank");
    },

    changeProspectType(prospect, type) {
      this.$emit("changeProspectType", { prospect, type });
    },

    sortChangeHandler(sortBy) {
      this.$emit("sortChange", sortBy);
    },
  },
};
</script>

<style lang="scss">
.user-link {
  color: var(--brand-primary);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.commercials-ctn,
.block-ctn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.commercials-ctn {
  padding: 0 5px;
  overflow: auto;

  div {
    margin-right: 5px;
    display: inline-block;
    padding: 0 5px;
    max-height: 28px;
  }
}

.action-btn {
  padding: 5px;
  cursor: pointer;
}
</style>
